import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useIntl } from 'react-intl-next';

import confluenceProjectPages from './assets/confluence-project-pages.png';

type ProjectPagesSpotlightProps = {
	flow: string;
	onView: () => void;
	onDismiss: () => void;
};

export const ProjectPagesSpotlight = ({ flow, onView, onDismiss }: ProjectPagesSpotlightProps) => {
	const intl = useIntl();

	const couseTitle = intl.formatMessage({
		defaultMessage: 'Your project has Confluence pages',
		description: 'Your project has Confluence pages',
		id: 'jira-project-space-connected.message-templates.spotlight-header-couse',
	});

	const xflowTitle = intl.formatMessage({
		defaultMessage: 'Add pages to your project',
		description: 'Add pages to your project',
		id: 'jira-project-space-connected.message-templates.spotlight-header-xflow',
	});

	const couseDescription = intl.formatMessage({
		defaultMessage: 'Create pages for your project without leaving Jira.',
		description: 'Create pages for your project without leaving Jira.',
		id: 'jira-project-space-connected.message-templates.spotlight-description-couse',
	});

	const xflowDescription = intl.formatMessage({
		defaultMessage: 'Create Confluence pages within Jira. Free for 10 users.',
		description: 'Create Confluence pages within Jira. Free for 10 users.',
		id: 'jira-project-space-connected.message-templates.spotlight-description-xflow',
	});

	const { messageInstanceClicked } = useMessageInstanceEvent();

	const handleDismiss = () => {
		onDismiss();
		void messageInstanceClicked({
			action: {
				actionType: 'dismiss',
			},
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'dismiss',
				clickedElement: 'button',
				buttonType: 'secondary',
			},
			additionalMetadataFromFrontend: {},
		});
	};

	const handleView = () => {
		onView();
		void messageInstanceClicked({
			action: {
				actionType: 'open',
				destinationUrl: '/pages',
			},
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'view',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			additionalMetadataFromFrontend: {},
		});
	};

	return (
		<SpotlightTransition>
			<Spotlight
				image={confluenceProjectPages}
				dialogWidth={275}
				targetBgColor={token('color.text.inverse')}
				actions={[
					{
						onClick: handleView,
						text: 'View',
					},
					{
						onClick: handleDismiss,
						text: 'Dismiss',
					},
				]}
				heading={flow === 'coUse' ? couseTitle : xflowTitle}
				target="horizontal-nav-tabs.PAGES"
				key="jira-project-space-connected"
				targetRadius={3}
			>
				{flow === 'coUse' ? couseDescription : xflowDescription}
			</Spotlight>
		</SpotlightTransition>
	);
};
